var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstimeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 24.4444C36.9801 21.2 40 17.3111 40 12.2222C40 8.98069 38.8412 5.87192 36.7782 3.5798C34.7153 1.28769 31.9174 0 29.0001 0C25.48 0 23.0001 1.11111 20.0001 4.44444C17.0001 1.11111 14.52 0 11 0C8.08263 0 5.28473 1.28769 3.22182 3.5798C1.15893 5.87192 0 8.98069 0 12.2222C0 17.3333 3 21.2223 6.00001 24.4444L20.0001 40L34 24.4444Z",
    fill: "#F93E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimeIcon);
export default __webpack_public_path__ + "static/media/estime_icon.83e589839552b083302f324e3af550a1.svg";
export { ForwardRef as ReactComponent };